import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/internal/Observable';

@Component({
    selector: 'app-prevision-definitive',
    templateUrl: './prevision-definitive.component.html',
    styleUrls: ['./prevision-definitive.component.scss'],
    standalone: false
})
export class PrevisionDefinitiveComponent implements OnInit {
    @Input() public recoltes;
    @Input() public campagnePrecedente;
    @Input() public estDefinitive;
    @Input() public alerteBio;
    @Input() public alerteSaisie;

    @ViewChild('form', { static: true }) form: NgForm;
    formGroup: UntypedFormGroup;

    hasErrors = false;

    getData(): Observable<Document[]> {
        throw new Error('Method not implemented.');
    }

    constructor(
        public readonly modal: NgbActiveModal,
        private readonly fb: UntypedFormBuilder,
        private readonly translate: TranslateService,
        private readonly toastr: ToastrService
    ) {
        //super(modal);
    }

    ngOnInit() {
        this.formGroup = this.fb.group({
            previsionOuDefinitive: ['', Validators.minLength(1)]
        });
    }

    save() {
        let r = this.formGroup.get('previsionOuDefinitive').value;
        this.hasErrors = (!r || r.length === 0) && !this.estDefinitive;
        if (!this.hasErrors) {
            this.modal.close(this.formGroup.get('previsionOuDefinitive').value || this.estDefinitive);
        }
    }

    cancel() {
        this.modal.close();
    }
}
